import { Component } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, RefreshCw } from "lucide-react";

export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        if (process.env.NODE_ENV !== "production") {
            console.error("Route render failed", error, info);
        }
    }

    render() {
        if (!this.state.hasError) return this.props.children;

        return (
            <div className="min-h-dvh flex items-center justify-center px-6 py-24">
                <div className="max-w-md w-full rounded-xl border border-white/10 bg-[#0d1526]/90 p-7 text-center shadow-2xl">
                    <div className="mx-auto mb-4 h-12 w-12 rounded-xl bg-red-starter/15 flex items-center justify-center">
                        <AlertTriangle size={24} className="text-red-starter" />
                    </div>
                    <h1 className="font-heading text-2xl font-semibold text-text-primary mb-2">Something went wrong</h1>
                    <p className="text-text-secondary text-sm leading-relaxed mb-6">
                        The page hit an unexpected rendering error. Your saved profile data is safe.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-3 justify-center">
                        <button
                            type="button"
                            onClick={() => {
                                this.setState({ hasError: false });
                                window.location.reload();
                            }}
                            className="inline-flex items-center justify-center gap-2 rounded-xl bg-blue-primary px-5 py-2.5 text-sm font-medium text-white"
                        >
                            <RefreshCw size={15} /> Reload
                        </button>
                        <Link
                            to="/genz-credit-scoring"
                            className="inline-flex items-center justify-center rounded-xl border border-white/10 px-5 py-2.5 text-sm font-medium text-text-primary hover:bg-white/5"
                        >
                            Go Home
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}
